import React, { Component } from "react";
import { DEFAULT_PROP, OPACITY_MAP } from "./const";
import "./index.scss";

export class MessageBoxEl extends Component<any, any> {
  timer: any;
  static defaultProps: {
    show: boolean;
    children: null;
    className: string;
    type: string;
    title: string;
    message: string;
    timeout: number;
    opacity: string;
    lockScroll: boolean;
    backgroundFn: boolean;
    formatFn: () => void;
    showConfirmButton: boolean;
    showCancelButton: boolean;
    showCloseIcon: boolean;
    confirmButtonText: string;
    cancelButtonText: string;
  };
  constructor(props) {
    super(props);

    this.timer = null;
    this.state = {
      ...props,
    };

    this.handleAction = this.handleAction.bind(this);
    this.backgroundFunc = this.backgroundFunc.bind(this);
  }

  toggleLockScroll() {
    const { lockScroll } = this.state;
    if (lockScroll) {
      document.body.style.overflow =
        document.body.style.overflow !== "hidden" ? "hidden" : "";
    }
  }

  // 定时关闭
  timeOut() {
    const { timeout } = this.state;
    if (timeout) {
      this.timer = setTimeout(() => {
        this.handleAction("confirm");
      }, timeout);
    }
  }

  // 确定/取消回调
  handleAction(action, data?) {
    const { callback } = this.state;
    this.close(() => {
      this.toggleLockScroll();
      if (action !== "close") {
        typeof callback === "function" && callback(action, data);
      }
    });
  }

  // 更新弹窗内容
  update(options) {
    this.open();
    this.setState(
      {
        ...options,
      },
      () => {
        this.toggleLockScroll();
        this.timeOut();
      }
    );
  }

  // 打开弹窗
  open(cb?) {
    this.setState(
      {
        show: true,
      },
      () => {
        typeof cb === "function" && cb();
      }
    );
  }

  // 关闭弹窗
  close(cb) {
    this.setState(
      {
        show: false,
      },
      () => {
        typeof cb === "function" && cb();
      }
    );
  }

  // 背景弹窗的事件
  backgroundFunc(e) {
    const { backgroundFn } = this.state;
    if (e.target === e.currentTarget && backgroundFn) {
      if (backgroundFn === true) {
        this.handleAction("cancel");
        return;
      }
      const flag = typeof backgroundFn === "function" && backgroundFn();
      if (flag === true) {
        this.handleAction("cancel");
      }
    }
  }

  componentDidMount() {
    this.toggleLockScroll();
    this.timeOut();
  }

  render() {
    const { className, type, show, opacity } = this.state;
    const clsN = "message-box-wrapper " + (className || "");
    const styles = {
      display: show ? "block" : "none",
      background: `rgba(0, 0, 0, ${OPACITY_MAP[opacity]})`,
    };
    return (
      <div onClick={this.backgroundFunc} className={clsN} style={styles}>
        {type === "confirm" && (
          <Confirm {...this.state} handleAction={this.handleAction} />
        )}
        {type === "alert" && (
          <Alert {...this.state} handleAction={this.handleAction} />
        )}
        {type === "toast" && <Toast {...this.state} />}
        {type === "custom" && <Custom {...this.state} instance={this} />}
      </div>
    );
  }
}

// alert组件
export const Alert = (props) => {
  const {
    showConfirmButton,
    handleAction,
    title,
    message,
    confirmButtonText,
    children,
  } = props;
  return (
    <div className="message-box-alert">
      <div className="message-box-header">
        <div className="message-box-title">{title}</div>
      </div>
      <div className="message-box-content">
        <div className="message-box-message">{children || message}</div>
      </div>
      <div className="message-box-btn">
        {showConfirmButton && (
          <div
            className="message-box-confirm-btn"
            onClick={() => handleAction("confirm")}
          >
            <p>{confirmButtonText}</p>
          </div>
        )}
      </div>
    </div>
  );
};

// confirm组件
export const Confirm = (props) => {
  const {
    cancelButtonText,
    showCloseIcon,
    showCancelButton,
    showConfirmButton,
    handleAction,
    title,
    message,
    confirmButtonText,
    children,
  } = props;
  return (
    <div className="message-box-confirm">
      <div className="message-box-header">
        {showCloseIcon && (
          <div
            className="message-box-icon-close"
            onClick={() => handleAction("close")}
          />
        )}
        <div className="message-box-title">{title}</div>
      </div>
      <div className="message-box-content">
        <div className="message-box-message">{children || message}</div>
      </div>
      <div className="message-box-btn">
        {showCancelButton && (
          <div
            className="message-box-cancel-btn"
            onClick={() => handleAction("cancel")}
          >
            <p>{cancelButtonText}</p>
          </div>
        )}
        {showConfirmButton && (
          <div
            className="message-box-confirm-btn"
            onClick={() => handleAction("confirm")}
          >
            <p>{confirmButtonText}</p>
          </div>
        )}
      </div>
    </div>
  );
};

// Toast组件
export const Toast = (props) => {
  const { message, children } = props;
  return (
    <div className="message-box-toast">
      <div className="message-box-content">{children || message}</div>
    </div>
  );
};

// Custom自定义组件
export const Custom = (props) => {
  const { message, instance, children } = props;
  return (
    <div className="message-box-custom">
      {children ||
        (typeof message === "function" ? message(instance) : message)}
    </div>
  );
};

MessageBoxEl.defaultProps = {
  ...DEFAULT_PROP,
};
